const SolidCrossIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0013 1.66663C5.39297 1.66663 1.66797 5.39163 1.66797 9.99996C1.66797 14.6083 5.39297 18.3333 10.0013 18.3333C14.6096 18.3333 18.3346 14.6083 18.3346 9.99996C18.3346 5.39163 14.6096 1.66663 10.0013 1.66663ZM13.5846 13.5833C13.2596 13.9083 12.7346 13.9083 12.4096 13.5833L10.0013 11.175L7.59297 13.5833C7.26797 13.9083 6.74297 13.9083 6.41797 13.5833C6.09297 13.2583 6.09297 12.7333 6.41797 12.4083L8.8263 9.99996L6.41797 7.59163C6.09297 7.26663 6.09297 6.74163 6.41797 6.41663C6.74297 6.09163 7.26797 6.09163 7.59297 6.41663L10.0013 8.82496L12.4096 6.41663C12.7346 6.09163 13.2596 6.09163 13.5846 6.41663C13.9096 6.74163 13.9096 7.26663 13.5846 7.59163L11.1763 9.99996L13.5846 12.4083C13.9013 12.725 13.9013 13.2583 13.5846 13.5833Z"
        fill="#E92C2C"
      />
    </svg>
  );
};

export default SolidCrossIcon;
